import angular from 'angular';
import loadingIndicatorComponent from './loadingIndicator.component';


let loadingIndicatorModule = angular.module('loadingIndicator', [
])

.component('loadingIndicator', loadingIndicatorComponent);

export default loadingIndicatorModule;



// WEBPACK FOOTER //
// ./client/common/loadingIndicator/loadingIndicator.js